import React, { useState } from "react";
import { Button, Collapse, Form, Input, Tag } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import AddKpiModal from "../modal/add/AddKpiModal";
import CascadePlanModal from "../modal/CascadePlanModal";
import SplitPlanModal from "../modal/SplitPlanModal";
import { Link } from "react-router-dom";

const { Panel } = Collapse;

function PlanCollapseOrg() {
  const [addKpi, setAddKpi] = useState(false);
  const [cascade, setCascade] = useState(false);
  const [split, setSplit] = useState(false);

  return (
    <>
      <div className="max-w-5xl">
        <Collapse>
          <Panel
            header={
              <div className="flex justify-between w-full items-center">
                <div>
                  <div className="flex items-center mb-1">
                    <Tag color="blue">Objective</Tag>
                    <Tag>Financial</Tag>
                    <div className="text-xs text-gray-400">Jun 23 2022</div>
                  </div>
                  Revenue target for the financial year - 10 Million LKR
                </div>
                <div>
                  <Tag color="Red">
                    <div className="text-sm">10%</div>
                  </Tag>
                </div>
              </div>
            }
            key="1"
          >
            <div className="text-xs">Target</div>
            <div className="mb-3">1,000,000 LKR / 10,000,000 LKR</div>

            <div className="text-xs">Description</div>
            <div className="mb-3">
              This is the description of the objective assigned.
            </div>

            <div className="text-lg">KPIs</div>
            <div className="mb-5 max-w-4xl">
              <Collapse bordered={false}>
                <Panel
                  header={
                    <div className="flex justify-between w-full">
                      <div>Acquisition of new customers - 5 Million LKR</div>
                      <div>
                        <Tag color="Red">10%</Tag>
                      </div>
                    </div>
                  }
                  key="1"
                >
                  <div className="px-6">
                    <div className="flex items-center mb-3">
                      <div>
                        <Input placeholder="Amount" />
                      </div>
                      <div className="mx-3">/ 10000000</div>
                      <Button htmlType="submit">Update</Button>
                    </div>
                    <div>
                      <Button className="mr-2" danger>
                        <DeleteOutlined />
                      </Button>
                      <Button>
                        <EditOutlined />
                      </Button>
                    </div>
                  </div>
                </Panel>
                <Panel
                  header={
                    <div className="flex justify-between w-full">
                      <div>Cross selling - 5 Million LKR</div>
                      <div>
                        <Tag color="Red">10%</Tag>
                      </div>
                    </div>
                  }
                  key="2"
                >
                  <div className="px-6">
                    <div className="flex items-center mb-3">
                      <div>
                        <Input placeholder="Amount" />
                      </div>
                      <div className="mx-3">/ 10000000</div>
                      <Button htmlType="submit">Update</Button>
                    </div>
                    <div>
                      <Button className="mr-2" danger>
                        <DeleteOutlined />
                      </Button>
                      <Button>
                        <EditOutlined />
                      </Button>
                    </div>
                  </div>
                </Panel>
                <div className="py-3 px-4">
                  <div
                    onClick={() => setAddKpi(true)}
                    className="cursor-pointer text-blue-500"
                  >
                    + Add new KPI
                  </div>
                </div>
              </Collapse>
            </div>

            <div className="flex justify-between">
              <div>
                <Button className="mr-2" danger>
                  <DeleteOutlined />
                </Button>
                <Button>
                  <EditOutlined />
                </Button>
              </div>
              <div>
                <Button onClick={() => setCascade(true)} className="mr-2">
                  Cascade
                </Button>
                <Button onClick={() => setSplit(true)} className="mr-2">
                  Split
                </Button>
                <Link to="/plan">
                  <Button className="mr-2">More</Button>
                </Link>
              </div>
            </div>
          </Panel>

          <Panel
            header={
              <div className="flex justify-between w-full items-center">
                <div>
                  <div className="flex items-center mb-1">
                    <Tag color="green">Goal</Tag>
                    <Tag>Internal</Tag>
                    <div className="text-xs text-gray-400">Jun 23 2022</div>
                  </div>
                  Total collections - 5 Million LKR
                </div>
                <div>
                  <Tag color="Orange">
                    <div className="text-sm">50%</div>
                  </Tag>
                </div>
              </div>
            }
            key="2"
          >
            <div className="text-xs">Target</div>
            <div className="mb-3">1,000,000 LKR / 10,000,000 LKR</div>

            <div className="text-xs">Description</div>
            <div className="mb-3">
              This is the description of the objective assigned.
            </div>

            <div className="text-lg">KPIs</div>
            <div className="mb-5 max-w-4xl">
              <Collapse bordered={false}>
                <Panel
                  header={
                    <div className="flex justify-between w-full">
                      <div>Acquisition of new customers - 5 Million LKR</div>
                      <div>
                        <Tag color="Red">10%</Tag>
                      </div>
                    </div>
                  }
                  key="1"
                >
                  <div className="px-6">
                    <div className="flex items-center mb-3">
                      <div>
                        <Input placeholder="Amount" />
                      </div>
                      <div className="mx-3">/ 10000000</div>
                      <Button htmlType="submit">Update</Button>
                    </div>
                    <div>
                      <Button className="mr-2" danger>
                        <DeleteOutlined />
                      </Button>
                      <Button>
                        <EditOutlined />
                      </Button>
                    </div>
                  </div>
                </Panel>
                <Panel
                  header={
                    <div className="flex justify-between w-full">
                      <div>Cross selling - 5 Million LKR</div>
                      <div>
                        <Tag color="Red">10%</Tag>
                      </div>
                    </div>
                  }
                  key="2"
                >
                  <div className="px-6">
                    <div className="flex items-center mb-3">
                      <div>
                        <Input placeholder="Amount" />
                      </div>
                      <div className="mx-3">/ 10000000</div>
                      <Button htmlType="submit">Update</Button>
                    </div>
                    <div>
                      <Button className="mr-2" danger>
                        <DeleteOutlined />
                      </Button>
                      <Button>
                        <EditOutlined />
                      </Button>
                    </div>
                  </div>
                </Panel>
                <div className="py-3 px-4">
                  <div
                    onClick={() => setAddKpi(true)}
                    className="cursor-pointer text-blue-500"
                  >
                    + Add new KPI
                  </div>
                </div>
              </Collapse>
            </div>

            <div className="flex justify-between">
              <div>
                <Button className="mr-2" danger>
                  <DeleteOutlined />
                </Button>
                <Button>
                  <EditOutlined />
                </Button>
              </div>
              <div>
                <Button onClick={() => setSplit(true)} className="mr-2">
                  Split
                </Button>
                <Link to="/plan">
                  <Button className="mr-2">More</Button>
                </Link>
              </div>
            </div>
          </Panel>

          <Panel
            header={
              <div className="flex justify-between w-full items-center">
                <div>
                  <div className="flex items-center mb-1">
                    <Tag color="orange">Action</Tag>
                    <Tag>Customer</Tag>
                    <div className="text-xs text-gray-400">Jun 23 2022</div>
                  </div>
                  Acquire new customers - 20
                </div>
                <div>
                  <Tag color="Green">
                    <div className="text-sm">90%</div>
                  </Tag>
                </div>
              </div>
            }
            key="3"
          >
            <div className="text-xs">Target</div>
            <div className="mb-3">1,000,000 LKR / 10,000,000 LKR</div>

            <div className="text-xs">Description</div>
            <div className="mb-3">
              This is the description of the objective assigned.
            </div>

            <div className="text-lg">KPIs</div>
            <div className="mb-5 max-w-4xl">
              <Collapse bordered={false}>
                <Panel
                  header={
                    <div className="flex justify-between w-full">
                      <div>Acquisition of new customers - 5 Million LKR</div>
                      <div>
                        <Tag color="Red">10%</Tag>
                      </div>
                    </div>
                  }
                  key="1"
                >
                  <div className="px-6">
                    <div className="flex items-center mb-3">
                      <div>
                        <Input placeholder="Amount" />
                      </div>
                      <div className="mx-3">/ 10000000</div>
                      <Button htmlType="submit">Update</Button>
                    </div>
                    <div>
                      <Button className="mr-2" danger>
                        <DeleteOutlined />
                      </Button>
                      <Button>
                        <EditOutlined />
                      </Button>
                    </div>
                  </div>
                </Panel>
                <Panel
                  header={
                    <div className="flex justify-between w-full">
                      <div>Cross selling - 5 Million LKR</div>
                      <div>
                        <Tag color="Red">10%</Tag>
                      </div>
                    </div>
                  }
                  key="2"
                >
                  <div className="px-6">
                    <div className="flex items-center mb-3">
                      <div>
                        <Input placeholder="Amount" />
                      </div>
                      <div className="mx-3">/ 10000000</div>
                      <Button htmlType="submit">Update</Button>
                    </div>
                    <div>
                      <Button className="mr-2" danger>
                        <DeleteOutlined />
                      </Button>
                      <Button>
                        <EditOutlined />
                      </Button>
                    </div>
                  </div>
                </Panel>
                <div className="py-3 px-4">
                  <div
                    onClick={() => setAddKpi(true)}
                    className="cursor-pointer text-blue-500"
                  >
                    + Add new KPI
                  </div>
                </div>
              </Collapse>
            </div>

            <div className="flex justify-between">
              <div>
                <Button className="mr-2" danger>
                  <DeleteOutlined />
                </Button>
                <Button>
                  <EditOutlined />
                </Button>
              </div>
              <div>
                <Button onClick={() => setSplit(true)} className="mr-2">
                  Split
                </Button>
                <Link to="/plan">
                  <Button className="mr-2">More</Button>
                </Link>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>
      <AddKpiModal visible={addKpi} handleCancel={() => setAddKpi(false)} />
      <CascadePlanModal
        visible={cascade}
        handleCancel={() => setCascade(false)}
      />
      <SplitPlanModal visible={split} handleCancel={() => setSplit(false)} />
    </>
  );
}

export default PlanCollapseOrg;
